import { Flow_0_0_2 } from '@flexus/core';

export const BET_3: Flow_0_0_2 = {
	id: '3',
	name: 'valid_work_in_progress',
	itemType: 'flow',
	header: {
		title: 'Work In Progress',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
